import { MessageCircle, Mail, Activity, Globe } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-teal/10 py-12">
      <div className="container">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/androhost-rocket.svg" alt="" className="h-9 w-auto" />
              <span className="display text-xl tracking-wider text-offwhite">
                ANDRO<span className="text-red">HOST</span>
              </span>
            </div>
            <p className="text-offwhite/65 text-sm max-w-md leading-relaxed">
              Live status of the AndroHost platform, game nodes, and edge network. Monitors are auto-discovered from our network, no manual entry.
            </p>
          </div>

          <div>
            <h4 className="display text-sm tracking-wider text-offwhite/80 mb-3 uppercase">Product</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="https://www.androhost.com/#games" className="text-offwhite/65 hover:text-teal transition-colors">Games</a></li>
              <li><a href="https://www.androhost.com/#free-tier" className="text-offwhite/65 hover:text-teal transition-colors">Free tier</a></li>
              <li><a href="https://www.androhost.com/#pricing" className="text-offwhite/65 hover:text-teal transition-colors">Pricing</a></li>
              <li><a href="https://panel.androhost.com" className="text-offwhite/65 hover:text-teal transition-colors" target="_blank" rel="noopener noreferrer">Panel</a></li>
            </ul>
          </div>

          <div>
            <h4 className="display text-sm tracking-wider text-offwhite/80 mb-3 uppercase">Connect</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="https://www.androhost.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-offwhite/65 hover:text-teal transition-colors">
                  <Globe className="w-4 h-4" /> androhost.com
                </a>
              </li>
              <li>
                <a href="https://discord.gg/9Y5zpKnfws" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-offwhite/65 hover:text-teal transition-colors">
                  <MessageCircle className="w-4 h-4" /> Discord
                </a>
              </li>
              <li>
                <a href="https://status.androhost.com" className="flex items-center gap-2 text-teal">
                  <Activity className="w-4 h-4" /> Status
                </a>
              </li>
              <li>
                <a href="mailto:support@androhost.com" className="flex items-center gap-2 text-offwhite/65 hover:text-teal transition-colors">
                  <Mail className="w-4 h-4" /> support@androhost.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-teal/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-offwhite/45">
          <div>© 2026 Andromedacraft Hosting LLC. AndroHost is a service of Andromedacraft Hosting LLC.</div>
          <div className="display tracking-widest text-teal/55">WHERE WORLDS TAKE FLIGHT</div>
        </div>
      </div>
    </footer>
  );
}
